import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import useModalStore from '../hooks/useModalStore.js';

const ModalOrchestrator = () => {
  const {
    metaModals,
    closeModal,
    registry
  } = useModalStore();

  // If there is no modals, render null
  if (metaModals.length === 0) {
    return null;
  }

  // TODO: Implement a solution to keep all modals rendered but hidden
  // when not in use, so we don't lose the state of the modal
  const renderModal = () => {
    const metaModal = metaModals[metaModals.length - 1];
    const ModalComponent = registry[metaModal.type];
    if (ModalComponent) {
      return /*#__PURE__*/React.createElement(ModalComponent, _extends({}, metaModal.payload, {
        closeModal: () => closeModal(metaModal.key)
      }));
    }

    // eslint-disable-next-line no-console
    console.log(`Error: Modal type "${metaModal.type}" is not registered in the Modal Store registry.`);
    return null;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, renderModal());
};
var ModalOrchestrator$1 = ModalOrchestrator;

export { ModalOrchestrator$1 as default };
//# sourceMappingURL=ModalOrchestrator.js.map
